/**
 * Coerce any input into a string suitable for passing to ReactMarkdown.
 * null/undefined become '' so the caller can short-circuit with a truthiness
 * check; strings pass through unchanged; everything else is stringified.
 */
export const toMarkdownString = (raw: unknown): string => {
  if (raw === null || raw === undefined) {
    return '';
  }
  if (typeof raw === 'string') {
    return raw;
  }
  return String(raw);
};
